<template>
  <badge :type="getBadgeType()">
    {{ $t(`EQUIPMENT_TRANSFERS.STATUS_${transfer.status}`) }}
  </badge>
</template>

<script>
import { equipmentTransferStatuses } from "@/constants/equipmentTransfers";

export default {
  name: "equipment-transfer-status-badge",
  props: {
    transfer: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getBadgeType() {
      const status = equipmentTransferStatuses.find(
        (item) => item.value === this.transfer.status
      );
      return status ? status.type : "default";
    },
  },
};
</script>
